import PropTypes from 'prop-types';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJTextToFullVideoStart.module.less';
import FJScriptAssistantIcon from '../../../assets/svg/textToVideo/ai-script-assistant.svg?react';
import FJUseExistingScriptIcon from '../../../assets/svg/textToVideo/use-existing-script.svg?react';
import classNames from 'classnames';
import aiScriptAssistantBg from '../../../assets/base64/ai-script-assistant-bg.js';
import useExistingScriptBg from '../../../assets/base64/use-existing-script-bg.js';
import FJScriptEditorInputContainer from '../FJScriptEditorInput/FJScriptEditorInputContainer';
import FJFreeTimesSpan from '../FJFreeTimesSpan/FJFreeTimesSpan.jsx';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import { TEXT_TO_VIDEO_PRICE } from '../../../config/dataConfig/FJTextToVideoDataConfig.js';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import FJUtil from '../../../util/FJUtil.js';

const FJTextToFullVideoStart = props => {
    const { onGenerateScript, gotoPasteScript, freeTimes, creditNumber, defaultFreeNumCreation } = props;
    const isFree = freeTimes > 0 && creditNumber < TEXT_TO_VIDEO_PRICE.textToScript;
    const isLogin = FJUtil.isLogin();
    return (
        <div className={styles.container}>
            <FJVerticalScroller className={styles.content}>
                <div className={styles.title}>{FJLocalStore._('ai-text-to-full-video')}</div>
                <div className={styles.main_box}>
                    <div className={styles.script_box} style={{ backgroundImage: `url(${aiScriptAssistantBg})` }}>
                        <div className={styles.script_header}>
                            <div className={styles.header_icon_box}>
                                <FJScriptAssistantIcon />
                            </div>
                            <div className={styles.script_header_title}>
                                {FJLocalStore._('generate-scripts-with-ai')}
                            </div>
                        </div>
                        <div className={styles.script_desc}>
                            {FJLocalStore._('describe-your-idea-and-ai-will-generate-a-video-script-for-you')}
                        </div>
                        <FJScriptEditorInputContainer />
                        <div className={styles.btn_box}>
                            <FJGenerateButton
                                text={FJLocalStore._('generate')}
                                className={styles.btn}
                                onClick={onGenerateScript}
                                isFree={isFree}
                                useCredit={TEXT_TO_VIDEO_PRICE.textToScript}
                                hideFreeCreation={true}
                                defaultFreeNumCreation={defaultFreeNumCreation}
                            />
                            {!isLogin && defaultFreeNumCreation > 0 && (
                                <FJFreeTimesSpan desc={FJLocalStore._('free-try')} />
                            )}
                            {isFree && isLogin && <FJFreeTimesSpan times={freeTimes} />}
                        </div>
                    </div>

                    <div
                        className={classNames(styles.script_box, styles.use_existing_scriptBox)}
                        style={{ backgroundImage: `url(${useExistingScriptBg})` }}
                    >
                        <div className={styles.header_box}>
                            <div className={styles.script_header}>
                                <div className={styles.header_icon_box}>
                                    <FJUseExistingScriptIcon />
                                </div>
                                <div className={styles.script_header_title}>
                                    {FJLocalStore._('use-existing-scripts')}
                                </div>
                            </div>
                            <div className={styles.script_desc}>
                                {FJLocalStore._(
                                    'if-you-have-a-script-please-enter-or-paste-it-here-to-generate-a-video',
                                )}
                            </div>
                        </div>
                        <div className={classNames(styles.btn_box, styles.margin_top_129)}>
                            <FJButton
                                text={FJLocalStore._('enter-or-paste-script')}
                                className={styles.btn}
                                type={'gradient'}
                                onClick={gotoPasteScript}
                            />
                        </div>
                    </div>
                </div>
            </FJVerticalScroller>
        </div>
    );
};

FJTextToFullVideoStart.propTypes = {
    onGenerateScript: PropTypes.func,
    gotoPasteScript: PropTypes.func,
    freeTimes: PropTypes.number,
    creditNumber: PropTypes.number,
};

export default FJTextToFullVideoStart;
